import { render, staticRenderFns } from "./optionGoodsReg.vue?vue&type=template&id=5d9664f4"
import script from "./optionGoodsReg.vue?vue&type=script&lang=js"
export * from "./optionGoodsReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports